import Http from '@/ship/Http';
import { NotificationPostRequest, ServiceNotifications } from '@/ship/Models/Notifications/Notifications';
import ITransformedValue from '@/ship/Values/ITransformedValue';
import { AxiosResponse } from 'axios';

export const getUserNotificationsSettings = (): Promise<AxiosResponse<ITransformedValue<ServiceNotifications>>> => {
    return Http.get<ITransformedValue<ServiceNotifications>>(`/user/get/notification-settings`);
};

export const setUserNotificationsSettings = (params: NotificationPostRequest) => {
    return Http.post(`/user/set/notification-settings`, params);
};
